import { Component, ElementRef, ViewChild, inject, AfterViewInit, OnDestroy, signal, ChangeDetectorRef } from '@angular/core';import { Router } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InvestmentFlowService } from '../../../../core/services/Investment-flow/investment-flow.service';
import { NgClass } from '@angular/common';
import { AuthOtpService } from '../../../../core/auth/auth-otp.service';
import { ProfileService } from '../../../../core/services/Profile/profile.service';

@Component({
  selector: 'app-otp-modal',
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './otp-modal.component.html',
  styleUrl: './otp-modal.component.css',
})
export class OtpModalComponent implements AfterViewInit, OnDestroy {
  private readonly authOtpService = inject(AuthOtpService);
  public readonly flow = inject(InvestmentFlowService);
  private readonly router = inject(Router);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly profileService=inject(ProfileService);

  @ViewChild('otpInput') otpInput!: ElementRef<HTMLInputElement>;

  boxes = Array.from({ length: 6 }, (_, i) => i);

  resendCooldown = 30;
  canResend = false;
   isSending = signal(false);
  private resendInterval: ReturnType<typeof setInterval> | null = null;

  form = new FormGroup({
    otp: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\d{6}$/),
    ]),
  });

  get currentIndex() {
    const len = this.form.value.otp?.length || 0;
    return len >= 6 ? -1 : len;
  }

 ngAfterViewInit(): void {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (!isMobile) {
    setTimeout(() => {
      this.otpInput?.nativeElement.focus();
    }, 300);
  }

  this.startResendCooldown();
}
  ngOnDestroy(): void {
    this.clearResendInterval();
  }

  focusOtpInput(): void {
      this.otpInput?.nativeElement?.focus();

  }

  onOtpInput(): void {
    const value = this.form.value.otp || '';
    this.form.patchValue(
      {
        otp: value.replace(/\D/g, '').slice(0, 6),
      },
      { emitEvent: false }
    );
  }

  confirm(): void {
    if (this.form.invalid) return;

    const otpCode = this.form.value.otp!.trim();

   this.flow.verifyOtp(otpCode, (isNew) => {
  this.flow.close();

  this.profileService.getProfileData().subscribe({
    next: (res: any) => {
      const profile = res?.profile || res;

      const hasNationalId =
        !!profile?.national_id_front && !!profile?.national_id_back;

      const hasPassport =
        !!profile?.passport_image;

      const hasKycDocument = hasNationalId || hasPassport;

      if (isNew || !hasKycDocument) {
        this.router.navigate(['/profile']);
      } else {
        this.router.navigate(['/dashboard']);
      }
    },

    error: () => {
      this.router.navigate(['/profile']);
    }
  });
});
  }

  resendOtp(): void {
    if (!this.canResend || this.flow.loading()) return;

    const phone = this.flow.phone();
    if (!phone) return;

    this.flow.requestOtpAndOpen(phone);
    this.form.patchValue({ otp: '' });
    this.focusOtpInput();
    this.startResendCooldown();
  }

  private startResendCooldown(): void {
  this.clearResendInterval();

  this.canResend = false;
  this.resendCooldown = 30;
  this.cdr.detectChanges();

  this.resendInterval = setInterval(() => {
    this.resendCooldown--;

    if (this.resendCooldown <= 0) {
      this.clearResendInterval();
      this.canResend = true;
      this.resendCooldown = 0;
    }

    this.cdr.detectChanges();
  }, 1000);
}

  

  private clearResendInterval(): void {
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
      this.resendInterval = null;
    }
  }
}